/** ContactPickerRow / MemberRow (06 §4.16) — avatar + name + about; check on multi-select. */
import { Check } from 'lucide-react';
import type { User } from '../../data/model';
import { Avatar } from '../primitives/Avatar';
import styles from './ContactPickerRow.module.css';

interface Props {
  user: User;
  selected?: boolean;
  multiselect?: boolean;
  onClick: () => void;
}

export function ContactPickerRow({ user, selected, multiselect, onClick }: Props) {
  return (
    <button className={styles.row} onClick={onClick} aria-pressed={multiselect ? selected : undefined}>
      <span className={styles.avatarWrap}>
        <Avatar id={user.id} name={user.displayName} url={user.avatarUrl} size={44} />
        {multiselect && selected && (
          <span className={styles.check}>
            <Check size={14} strokeWidth={3} />
          </span>
        )}
      </span>
      <span className={styles.text}>
        <span className={styles.name}>{user.displayName}</span>
        <span className={styles.about}>{user.about}</span>
      </span>
    </button>
  );
}
